export default __webpack_public_path__ + "static/media/submitArticleBtn.62e06139.svg";